import React from "react";
import { RotatingLines } from "react-loader-spinner";

const CustomLoader = () => {
  return (
    <>
      <RotatingLines
        visible={true}
        height="56"
        width="56"
        color="grey"
        strokeWidth="3"
        animationDuration="0.9"
        ariaLabel="rotating-lines-loading"
        wrapperStyle={{}}
        wrapperClass=""
        strokeColor="#9C7726"
      />
    </>
  );
};

export default CustomLoader;
